import { PropsWithChildren } from "react";
import { MaatregelContext, MaatregelContextActions, MaatregelVariant, maatregelContextDefaults } from "./maatregel-context";

type MaatregelProviderProps = MaatregelVariant &
    Partial<MaatregelContextActions> & {
        isEditEnabled?: boolean;
    };

export function MaatregelProvider({ children, ...context }: Readonly<PropsWithChildren<MaatregelProviderProps>>) {
    const value = { ...maatregelContextDefaults, ...context };
    return <MaatregelContext value={value}>{children}</MaatregelContext>;
}
